export { default } from './BulletIndicator';
